'use client';

import { Tooltip as RadixTooltip } from 'radix-ui';
import type { ReactNode } from 'react';
import { Kbd } from './kbd';

/**
 * The tooltip's bubble: inverted ink, it fades in once the hover delay is over. Hidden on touch
 * screens, where nothing hovers.
 */
export const tooltipContentClass =
  'z-[75] flex max-w-[min(20rem,calc(100vw-1rem))] items-center gap-2 rounded-[5px] bg-crow-text px-2 py-1 text-crow-label font-medium text-crow-surface data-[state=closed]:animate-crow-fade-out data-[state=delayed-open]:animate-crow-fade-in [@media(hover:none)]:hidden';

/** Wrap the app once: tooltips open after 400 ms of hover and close at once. */
export function TooltipProvider({ children }: { children: ReactNode }) {
  return (
    <RadixTooltip.Provider delayDuration={400} skipDelayDuration={0}>
      {children}
    </RadixTooltip.Provider>
  );
}

export function Tooltip({
  label,
  shortcut,
  side = 'top',
  children,
}: {
  label: ReactNode;
  shortcut?: string;
  side?: 'top' | 'bottom' | 'left' | 'right';
  children: ReactNode;
}) {
  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content side={side} sideOffset={6} className={tooltipContentClass}>
          {label}
          {shortcut ? (
            <Kbd className="border-crow-text-2 text-crow-surface/70">{shortcut}</Kbd>
          ) : null}
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
}
